{
  "DATE_PICKER": {
    "APPLY_BUTTON": "Apply",
    "CLEAR_BUTTON": "Clear",
    "DATE_RANGE_INPUT": {
      "START": "Start Date",
      "END": "End Date"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "DATE RANGE",
      "TODAY": "Tänään",
      "YESTERDAY": "Eilen",
      "LAST_7_DAYS": "Viimeiset 7 päivää",
      "LAST_30_DAYS": "Viimeiset 30 päivää",
      "LAST_3_MONTHS": "Last 3 months",
      "LAST_6_MONTHS": "Last 6 months",
      "LAST_YEAR": "Last year",
      "CUSTOM_RANGE": "Custom date range"
    }
  }
}
